import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoachProfilesPage} from './coach-profiles/coach-profiles.page';
import {CoachRoutingModule} from './coach-routing.module';
import {NgSelectModule} from '@ng-select/ng-select';
import {CoachProfilePage} from './coach-profile/coach-profile.page';
import {CoachCalendarPage} from './coach-calendar/coach-calendar.page';
import {CoachAppointmentsPage} from './coach-appointments/coach-appointments.page';
import {CoachRequestsIncomingPage} from './coach-requests-incoming/coach-requests-incoming.page';
import {CoachAvailabilityPage} from './coach-availability/coach-availability.page';
import {CoachJourneyPage} from './coach-journey/coach-journey.page';
import { NgCalendarModule } from 'ionic2-calendar';
import {VideoChatModule} from '../video-chat/video-chat.module';
import {DirectivesModule} from '../../directives/directives.module';
import {MomentModule} from 'ngx-moment';
import {CoachGroupsDropdownComponent} from './coach-profiles/coach-groups-dropdown/coach-groups-dropdown.component';

import {CoachListComponent} from './components/coach-list/coach-list.component';
import {JourneyStagesComponent} from './components/journey-stages/journey-stages.component';
import {CoachProfileComponent} from './components/coach-profile/coach-profile.component';
import {AppointmentListComponent} from './components/appointment-list/appointment-list.component';
import {AppointmentCalendarComponent} from './components/appointment-calendar/appointment-calendar.component';
import {BlackSwitchComponent} from './components/black-switch/black-switch.component';
import {PercentRangeComponent} from './components/percent-range/percent-range.component';
import {PipesModule} from '../../pipes/pipes.module';

/// external
import {CoachFeedbackPage} from './coach-feedback/coach-feedback.page';
import {JourneyModule} from '../journey/journey.module';
import {CoachDropdownComponent} from './components/coach-dropdown/coach-dropdown.component';
import {ComponentsReviewModule} from '../review/components/components.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        IonicModule,
        CoachRoutingModule,
        NgCalendarModule,
        ComponentsModule,
        DirectivesModule,
        TranslateModule.forChild(),
        NgSelectModule,
        VideoChatModule,
        MomentModule,
        JourneyModule,
        ComponentsReviewModule
    ],
    declarations: [
        CoachProfilesPage,
        CoachProfilePage,
        CoachCalendarPage,
        CoachAppointmentsPage,
        CoachRequestsIncomingPage,
        CoachAvailabilityPage,
        CoachGroupsDropdownComponent,
        CoachDropdownComponent,
        CoachJourneyPage,
        CoachFeedbackPage,
        CoachListComponent,
        JourneyStagesComponent,
        CoachProfileComponent,
        AppointmentListComponent,
        AppointmentCalendarComponent,
        BlackSwitchComponent,
        PercentRangeComponent
    ]
})
export class CoachModule {
}
